import { Box, Grid, useTheme } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconPointFilled } from "@tabler/icons-react";

const MxDetailStatus = ({ color, label }: { color: string; label: string }) => {
  return (
    <Grid container gap={1} alignItems={"center"} position={"relative"}>
      <Box position={"absolute"} top={-7} left={-6}>
        <IconPointFilled size={30} color={color} />
      </Box>
      <Grid item xs={"auto"} position={"relative"} left={25}>
        <MxTypography
          variant="caption"
          fontWeight={400}
          color="primary.main"
          textTransform={"uppercase"}
        >
          {label}
        </MxTypography>
      </Grid>
    </Grid>
  );
};

export default MxDetailStatus;
